export default {"src":"/_next/static/media/grid-off.7efb787f.svg","height":17,"width":17};